export enum AudioSourceType {
	SUMMARY_PAGE = 'aiSummaryPage',
	SUMMARY_PAGE_CATCHUP = 'aiSummaryChanges',
	SUMMARY_PAGE_COMMENTS = 'aiSummaryComments',
}
